module.exports = __webpack_public_path__ + "static/media/example1.fddef976.png";